import { breakpoints } from '@bnnvara/breakpoints';
import { sixteenNineRatio } from '@bnnvara/themes';
import styled from 'styled-components';
import checkMarkIcon from "../assets/icon-checkmark-black.svg";
export const CardWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  border: 1px solid ${({
  theme
}) => theme.tertiary.main};
  flex-direction: column;
`;
export const ButtonMobile = styled.span`
  display: block;
  ${breakpoints.md} {
    display: none;
  }

  > a {
    width: max-content;
    margin: 0 auto;
    text-decoration: none;
  }
`;
export const ButtonDesktop = styled.span`
  display: none;
  ${breakpoints.md} {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > a {
    width: max-content;
    margin: 0 auto;
    text-decoration: none;
    position: absolute;
    bottom: 25px;
  }
`;
export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;

  ${breakpoints.md} {
    padding-bottom: 25px;
  }

  span {
    width: max-content;
    margin: 0 auto;
    text-decoration: none;
  }

  h2 {
    font-family: ${({
  theme
}) => theme.fonts.primary};
    font-size: 16px;
    line-height: 19px;
    font-weight: bold;
    overflow-wrap: break-word;
    color: ${({
  theme
}) => theme.base.black};
    margin: 0;
    padding-bottom: 16px;
    ${breakpoints.md} {
      line-height: 26px;
      font-size: 22px;
    }
  }

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    li {
      margin-bottom: 12px;
      line-height: 18px;
      background-image: url(${checkMarkIcon});
      background-repeat: no-repeat;
      background-position: 1px 7px;
      background-size: 16px 12px;
      padding-left: 28px;
    }
  }
`;
export const CardImageContainer = styled.picture`
  display: none;
  ${breakpoints.lg} {
    display: block;
    flex-shrink: 0;
    background-color: ${({
  theme
}) => theme.tertiary.dark};
    position: relative;
    padding-bottom: ${sixteenNineRatio};
    width: 100%;
    height: auto;
  }
`;
export const CardImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
`;
export const Description = styled.div`
  display: block;
  font-family: ${({
  theme
}) => theme.fonts.primary};
  font-size: 15px;
  line-height: 22px;
  color: ${({
  theme
}) => theme.base.black};
  overflow: hidden;
  margin-bottom: 10px;
  ${breakpoints.md} {
    height: 180px;
    margin-bottom: 44px;
  }
`;